export const CLASSNAMES = {
  ContextTrigger: 'lobe-context-trigger',
  DropdownMenuTrigger: 'lobe-dropdown-menu-trigger',
};
